<template>
  <div class="spinner">
    <!-- <v-progress-circular
      :size="70"
      :width="7"
      color="#455a64"
      indeterminate
    ></v-progress-circular> -->
    <v-img
      :src="require('../assets/images/spinner.svg')"
      contain
      height="100px"
    ></v-img>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {};
  }
};
</script>
<style scoped>
.spinner {
  position: fixed;
  left: 0;
  right: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 100%;
  background-color: #dbebf3;
  z-index: 555;
  top: 0;
  bottom: 0;
}
</style>
